import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { Catalog } from '../../Model/Catalog/Catalog';
import { Category } from '../../Model/Catalog/Category';
import { Product } from '../../Model/Catalog/Product';
import { TreeItem as TreeElement } from '../../Model/Dto/TreeItem';
import { DxTreeListComponent } from 'devextreme-angular';
import { CatalogTreeComponent } from '../../shared/catalog-tree/catalog-tree.component';
import { CatalogTreeFooterButton } from '../../Model/ui/CatalogTreeFooterButton';
import notify from 'devextreme/ui/notify';
import { Clipboard } from '../../Model/Dto/Clipboard';
import { ProductState } from '../../Model/Catalog/ProductState';
import { CustomerWiki } from '../../Model/System/CustomerWiki';
import { LanguageFlag } from '../../Model/Dto/LanguageFlag';
import { TranslateService } from '@ngx-translate/core';
import { custom } from 'devextreme/ui/dialog';
import { UserManagementService } from '../../Services/userManagment.service';
import { MassDataChangeService } from '../../Services/CatalogManagement/massDataChange.service';
import { ProductLogistic } from '../../Model/Catalog/ProductLogistic';
import { SearchForm } from '../../Model/Dto/SearchForm';
import { SearchFormsService } from '../../Services/SearchForms/searchforms.service';
import { SearchFormsComponent } from '../catalog/searchForms/search-forms.component';
import { ActivatedRoute, Router } from '@angular/router';
import dxTreeList from 'devextreme/ui/tree_list';
import { Location } from '@angular/common';
import { DxTreeListTypes } from 'devextreme-angular/ui/tree-list';
import { ValidationService } from '../../Services/Validation/validation.service';
import { Subscription } from 'rxjs';
import { MacroService } from 'app/Services/CatalogManagement/macro.service';
import {SystemService} from "../../Services/system.service";
import {CatalogService} from "../../Services/CatalogManagement/catalog.service";
import {LoginService} from "../../Services/login.service";
import {ProductStateService} from "../../Services/productState.service";
import {TranslationService} from "../../Services/translation.service";
import {ProductService} from "../../Services/CatalogManagement/product.service";

@Component({
    selector: 'catalog',
    templateUrl: 'browse.component.html',
    styleUrls: ['./browse.component.css'],
    standalone: false
})
export class CatalogComponent implements OnInit {
    @ViewChild(CatalogTreeComponent, { static: true })
    catalogTree: CatalogTreeComponent;

    get treeList(): DxTreeListComponent {
        return this.catalogTree?.treeList;
    }

    @ViewChild('searchFormsRef')
    searchFormsRef: SearchFormsComponent;

    @Input() routeBasePath: string = '/catalog';
    @Input() customerIdOverride: string;
    @Input() catalogIdOverride: string;

    @Input() additionalFilter: string;

    @Input() multiSelect: boolean = false;
    @Input() footerButtons: CatalogTreeFooterButton[] = [];

    private subscription: Subscription;
    public expandedRowKeys: any = [];
    public selectedCatalogId: string;
    public selectedCategoryId: string;
    public selectedProductId: string;
    public treeSelectedRowKeys: any = [];
    public productStates: string[] = new Array<string>();
    public languageCodes: string[];
    public massDataChange: boolean = false;
    public massGenerateKITexts: boolean = false;
    public searchText = '';
    public showFilter: boolean = false;
    public showInfoForOnboardingUser: boolean = false;
    public searchFormPopupVisible: boolean = false;
    public initialSearchForm: SearchForm;
    public refreshWithSearchForm: SearchForm;

    constructor(
        public translate: TranslateService,
        public validationService: ValidationService,
        public massDataService: MassDataChangeService,
        public userManagment: UserManagementService,
        private route: ActivatedRoute,
        private router: Router,
        private location: Location,
        public macroService: MacroService,
        public systemService: SystemService,
        private searchFormsService: SearchFormsService,
        public catalogService: CatalogService,
        public loginService: LoginService,
        public productStateService: ProductStateService,
        public translationService: TranslationService,
        public productService: ProductService,
    ) {
        this.buildContextMenu = this.buildContextMenu.bind(this);
        this.treeListMode = this.treeListMode.bind(this);
        this.setEmptyProduct = this.setEmptyProduct.bind(this);
        this.massCancel = this.massCancel.bind(this);
        this.saveGridInstance = this.saveGridInstance.bind(this);
        this.onContentReady = this.onContentReady.bind(this);
        this.showCombineCatalog = this.showCombineCatalog.bind(this);
        this.hideInfoDialog = this.hideInfoDialog.bind(this);
    }

    protected getCustomerId(): string {
        return this.customerIdOverride ?? this.loginService.currentCustomer.id;
    }

    private getCatalogId(): string {
        return this.catalogIdOverride ?? this.selectedCatalogId ?? this.catalogService.selectedCatalogId;
    }

    private goUrl(segments: string[]): void {
        const base = (this.routeBasePath || '/catalog').replace(/\/$/, '');
        const customerId = this.getCustomerId();
        const catalogId = this.getCatalogId();
        const path = [base, customerId, catalogId, ...segments].join('/');
        this.location.go(path);
    }

    isSearch(filter: any) {
        if (this.catalogService.selectedStates && this.catalogService.selectedStates.length > 0)
            return true;

        if (filter && filter.filterValue) return true;

        if (this.searchText) return true;

        return false;
    }

    async ngOnInit(): Promise<void> {
        this.searchFormsService.activeSearchForm = null;
        this.searchText = this.route.snapshot.queryParamMap.get('search') ?? '';

        let customerId = this.customerIdOverride ?? this.route.snapshot.paramMap.get('customerId')!;
        if (customerId != this.loginService.currentCustomer.id) {
            await this.loginService.setCustomer(customerId);
            if (this.catalogService.catalog && (this.catalogService.catalog.id != (this.catalogIdOverride ?? this.route.snapshot.paramMap.get('catalogId')))) {
                this.catalogService.catalog = null;
            }
        }

        this.catalogService.selectedCatalogId = this.catalogIdOverride ?? this.route.snapshot.paramMap.get('catalogId')!;
        if (this.catalogService.selectedCatalogId == '') {
            this.router.navigate(['/']);
            return;
        }

        if (this.catalogService.catalog == null) {
            this.catalogService
                .getCatalog(
                    this.catalogService.selectedCatalogId,
                    this.loginService.currentUser.customerId
                )
                .subscribe((catalog) => {
                    this.selectedCatalogId = catalog.id;
                    this.catalogService.catalog = catalog;
                });
        }

        this.translateTexts();

        //select das entsprechnde TreeItem jenachdem ob Parameter im Link stehen
        let productId = this.route.snapshot.paramMap.get('productId')!;
        let categoryId = this.route.snapshot.paramMap.get('categoryId')!;
        let catalogId = this.catalogIdOverride ?? this.route.snapshot.paramMap.get('catalogId')!;
        if (catalogId != null) {
            if (!this.catalogService.selectedCatalogId) {
                this.catalogService.selectedCatalogId = catalogId;
            }
        }

        if (productId != null && catalogId != null) {
            this.catalogService
                .GetProductTreeItem(productId, this.loginService.currentCustomer.id, '', catalogId)
                .subscribe(
                    (prod) => {
                        this.selectProductAfterSearch = prod;
                    },
                    () => {
                        console.log();
                    }
                );
        } else if (categoryId != null && catalogId != null) {
            this.catalogService
                .getCategory(categoryId, this.loginService.currentCustomer.id)
                .subscribe((category) => {
                    this.selectCategoryAfterSearch = category.id;
                });
        } else if (catalogId != null) {
            this.treeSelectedRowKeys = [catalogId];
        } else if (this.catalogService.selectedCatalogId != null) {
            this.treeSelectedRowKeys = [this.catalogService.selectedCatalogId];
        } else {
            this.systemService.notifyWarning(
                this.translate.instant('Der verlinkte Katalog existiert nicht in diesem Account')
            );
            this.router.navigate(['/catalogs']);
        }

        this.systemService.currentNavigationTitle = this.translate.instant('Katalog');


        this.refresh();

        this.subscription = this.catalogService.openItemInBrowseComponentTrigger.subscribe((productId) => {
            this.catalogService
                .GetProductTreeItem(
                    productId,
                    this.loginService.currentCustomer.id,
                    '',
                    this.selectedCatalogId
                )
                .subscribe((x) => {
                    this.selectProductAfterSearch = x;
                    this.catalogService.treeRefresh();
                });
        });

        this.loginService.getLanguages().subscribe(() => {
            this._languageFlags = this.loginService.languageFlags;
        });
        this.selectedTranslateLanguage = this.loginService.selectedTranslateLanguage;
        //  this.refresh();
        this.selectedStates = [];
        this.openItem('cat', this.catalogService.selectedCatalogId, false);

        this.catalogService.startMassGenerateKITexts.subscribe(() => {
            this.showMassGenerateKITexts();
        });

        var catalog = this.catalogService.catalogs.filter(x => x.id == this.catalogService.selectedCatalogId);
        if (catalog != null &&
            catalog.length > 0 &&
            !catalog[0].isDemoCatalog &&
            catalog[0].productCount > 0 &&
            this.loginService.hasAddonONBOARDING) {
            this.showInfoForOnboardingUser = true;
        }
    }

    TreeListInstance: dxTreeList;

    saveGridInstance(e) {
        this.TreeListInstance = e.component;
        this.catalogService.treeList = this.catalogTree?.treeList;
    }

    hideInfoDialog() {
        this.showInfoForOnboardingUser = false;
    }

    showCombineCatalog() {
        let demoCatalog = this.catalogService.catalogs.filter(x => x.isDemoCatalog == true);
        let targetCatalogId = demoCatalog[0].id;
        let sourceCatalogId = this.catalogService.selectedCatalogId;
        this.router.navigate([`/combineCatalogs/${targetCatalogId}/${sourceCatalogId}`]);
    }

    selectProductAfterSearch: TreeElement;
    selectCategoryAfterSearch: string;

    async onContentReady(e: DxTreeListTypes.ContentReadyEvent) {
        if (this.massDataChange && this.isSearch(undefined)) {
            var selectedKeys: string[] = e.component.getSelectedRowKeys();
            var selectedItemsWithoutProducts = selectedKeys.filter((x) => !x.includes('_'));
            if (selectedItemsWithoutProducts && selectedItemsWithoutProducts.length > 0) {
                e.component.deselectRows(selectedItemsWithoutProducts);
                this.systemService.notifyWarning(
                    this.translate.instant('Wenn der Filter aktiv ist, können nur Produkte selektiert werden!')
                );
            }
        }

        if (this.selectedCatalogId != null && this.selectedCatalogId != '000000000000000000000000') {
            await this.TreeListInstance.expandRow(this.selectedCatalogId);
        }

        if (this.selectCategoryAfterSearch == null && this.selectProductAfterSearch == null) {
            this.selectCategoryAfterSearch = null;
            this.selectProductAfterSearch = null;
            return;
        }
        let productTreeElement = this.selectProductAfterSearch;
        let categoryId = this.selectCategoryAfterSearch;
        this.selectCategoryAfterSearch = null;
        this.selectProductAfterSearch = null;

      if (productTreeElement != null) {
        const categoryId = String(productTreeElement.treeElementId).split('_')[1];

        await this.expandCategoryTreeToTheTop(categoryId);
        await this.TreeListInstance.expandRow(categoryId);
        await this.TreeListInstance.expandRow(productTreeElement.parent);
        await this.TreeListInstance.expandRow(productTreeElement.treeElementId);
        await this.TreeListInstance.selectRows([productTreeElement.treeElementId], false);
        } else {
            await this.expandCategoryTreeToTheTop(categoryId);
            await this.TreeListInstance.expandRow(categoryId);
            await this.TreeListInstance.selectRows([categoryId], false);
        }
    }

    async expandCategoryTreeToTheTop(categoryId: string): Promise<void> {
        let category = await this.catalogService
            .getCategory(categoryId, this.loginService.currentCustomer.id)
            .toPromise();

        if (category.parentCategoryId == '000000000000000000000000') {
            await this.TreeListInstance.expandRow(category.catalogId);
            return;
        }
        await this.expandCategoryTreeToTheTop(category.parentCategoryId);
        await this.TreeListInstance.expandRow(category.parentCategoryId);
    }
    get selectedStatesMode() {
        return this.catalogService.selectedStatesMode;
    }

    set selectedStates(values: string[]) {
        this.catalogService.selectedStates = values;
    }


  toggleSearchFormPopup(searchForm?: SearchForm) {
    this.initialSearchForm = searchForm ? { ...searchForm } : null;
    this.searchFormPopupVisible = true;
  }

  onSearchFormPopupVisibleChange(visible: boolean) {
    this.searchFormPopupVisible = visible;
  }

  onSearchFormSaved(searchForm: SearchForm) {
    this.refreshWithSearchForm = { ...searchForm };
    this.searchFormPopupVisible = false;
  }
  
  onSaveSearchForm = () => this.searchFormsRef?.onSave();
  onCancelSearchForm = () => this.searchFormsRef?.onCancel();

  executeSearchForm(searchForm: SearchForm) {
    console.log("executeSearchForm", searchForm);
    
    this.catalogService.searchBySearchForm(
      this.catalogService.selectedCatalogId,
      this.loginService.currentUser.customerId,      
      searchForm.id,
      searchForm.filterCondition,
      searchForm.searchOptions.map(criteria => ({
        systemKey: criteria.nextPimField.systemKey,
        elementKey: criteria.nextPimField.elementKey,
        field: criteria.nextPimField.field,
        operator: criteria.operator,
        dataType: criteria.dataType,
        value: criteria.value,
        valueTo: criteria.valueTo,
        values: criteria.values
      }))
    );
  }
    _languageFlags: LanguageFlag[];

    get languageFlags(): LanguageFlag[] {
        return this._languageFlags;
    }

    set languageFlags(value: LanguageFlag[]) {
        this._languageFlags = value;
    }

    refresh() {
        this.systemService.showMenu = true;
        this.catalogService.resetConnection();
        if (this.loginService.currentUser == null) {
            this.router.navigate(['/']);
            return;
        }
        this.catalogService.treeList = this.treeList;
        if (this.loginService.currentUser != null) {
            /*      this.modelService.catalogService.getCatalog(this.modelService.catalogService.selectedCatalogId, this.modelService.loginService.currentUser.customerId)
                    .subscribe(() => {
                      this.model = this.modelService.catalogService.catalog;
                      if (this.modelService.loginService.hasAddonShopWare && this.model.isPublic) {
                        this.modelService.catalogService.testShopConnection();
                      }

                      //this.openItem("cat", this.modelService.catalogService.selectedCatalogId, false);

                    });*/

            this.catalogService
                .getCustomerProductStates(this.loginService.currentUser.customerId)
                .subscribe((states: ProductState[]) => {
                    this.productStateService.productStates = new Array<string>();

                    states.forEach((s) => {
                        this.productStateService.productStates.push(s.name);
                    });
                });

            this.catalogService
                .getLanguageCodes()
                .subscribe(() => (this.languageCodes = this.catalogService.languageCodes));
        }
        this.loginService.selectedTranslateLanguage =
            this.loginService.currentCustomer.defaultLanguage;
        this.catalogService.isCatalogSelected = true;
        this.catalogService.isCategorySelected = false;
        this.catalogService.isProductSelected = false;
        this.translationService.productTranslation = null;
    }

    get selectedTranslateLanguage() {
        this.loginService.setLanguageFlags();
        return this.loginService.selectedTranslateLanguage;
    }

    set selectedTranslateLanguage(value) {
        this.loginService.selectedTranslateLanguage = value;
        this.translationService.productTranslation = null;
        if (this.catalogService.isProductSelected)
            this.translationService.getProductTranslation(
                this.catalogService.catalog.id,
                this.catalogService.product.id
            );
    }

    //MENU
    public tree: TreeElement[];
    public childs: TreeElement[];

    get canChangePassword() {
        if (this.loginService.currentUser != null) {
            return true;
        }
        return false;
    }

    //CONTEXTMENU
    private contextMenuVisible: boolean;
    public menuItems = [];

    showContextMenu() {
        this.contextMenuVisible = true;
    }

    onContextMenuShowing(e, item) {
        this.catalogService.selectTreeElement(item.key);
    }

    async itemClick(e, itemClickData) {
        console.log("click");
        let treeId = itemClickData.data.treeElementId;

        let txtYes = '';
        let txtNo = '';
        let txtMsg = '';
        let txtTitle = '';
        let myDialog: any;

        if (!e.itemData.items) {
            switch (e.itemData.id) {
                case 1: //Katalog duplizieren
                    notify(
                        { message: e.itemData.text + ' was clicked', position: { my: 'center top', at: 'center top' } },
                        'error',
                        1500
                    );
                    break;
                case 2: // Kategorie hinzufügen
                    if (this.catalogService.isCatalogSelected) {
                        this.catalogService.addCategory(
                            this.catalogService.catalog.id,
                            this.loginService.currentUser.customerId,
                            treeId
                        );
                        break;
                    }
                    await this.catalogService.addCategory(
                        this.selectedCategoryId,
                        this.loginService.currentUser.customerId,
                        treeId
                    );
                    break;
                case 5: // Produkt hinzufügen
                    if (this.catalogService.isCategorySelected) {
                        await this.catalogService.addProduct(
                            this.selectedCategoryId,
                            this.loginService.currentUser.customerId,
                            treeId
                        );
                    } else {
                        await this.catalogService.addProduct(
                            this.selectedProductId,
                            this.loginService.currentUser.customerId,
                            treeId
                        );
                    }
                    break;
                case 6: //Item einfügen in Kategorie
                    this.catalogService.pasteItem(this.selectedCategoryId);
                    break;
                case 9: //Produkt einfügen in Produkt
                    this.catalogService.pasteItem(this.selectedProductId);
                    break;
                case 14: //Kategorie einfügen
                    this.catalogService.pasteItem(this.catalogService.catalog.id);
                    break;
                case 7: // Kategorie löschen
                    this.translate.get('Ja').subscribe((text: string) => {
                        txtYes = text;
                    });
                    this.translate.get('Nein').subscribe((text: string) => {
                        txtNo = text;
                    });
                    this.translate.get('Soll die Kategorie wirklich gelöscht werden?').subscribe((text: string) => {
                        txtMsg = text;
                    });
                    this.translate.get('Wirklich löschen?').subscribe((text: string) => {
                        txtTitle = text;
                    });

                    myDialog = custom({
                        title: txtTitle,
                        messageHtml: txtMsg,
                        buttons: [
                            {
                                text: txtYes,
                                onClick: (e) => {
                                    return { buttonText: true };
                                }
                            },
                            {
                                text: txtNo,
                                onClick: (e) => {
                                    return { buttonText: false };
                                }
                            }
                        ]
                    });
                    myDialog.show().then((dialogResult) => {
                        if (dialogResult.buttonText == true) {
                            this.catalogService.remCategory(this.catalogService.category, treeId);
                        }
                    });

                    break;
                case 8: // Produkt duplizieren
                    let selectedRowObj = this.treeList.instance.getNodeByKey(treeId);
                    let parentNodeKey = selectedRowObj.parent.key;
                    this.catalogService.duplicateItem(
                        parentNodeKey,
                        false,
                        this.loginService.currentUser.customerId,
                        this.selectedProductId
                    );
                    break;
                case 0: // Remove löschen
                    this.translate.get('Ja').subscribe((text: string) => {
                        txtYes = text;
                    });
                    this.translate.get('Nein').subscribe((text: string) => {
                        txtNo = text;
                    });
                    this.translate.get('Soll das Produkt wirklich gelöscht werden?').subscribe((text: string) => {
                        txtMsg = text;
                    });
                    this.translate.get('Wirklich löschen?').subscribe((text: string) => {
                        txtTitle = text;
                    });

                    myDialog = custom({
                        title: txtTitle,
                        messageHtml: txtMsg,
                        buttons: [
                            {
                                text: txtYes,
                                onClick: (e) => {
                                    return { buttonText: true };
                                }
                            },
                            {
                                text: txtNo,
                                onClick: (e) => {
                                    return { buttonText: false };
                                }
                            }
                        ]
                    });
                    myDialog.show().then((dialogResult) => {
                        if (dialogResult.buttonText == true) {
                            this.catalogService.remProduct(this.catalogService.product, treeId);
                        }
                    });

                    break;
                case 10: //Kategorie kopieren
                    var clipboard = new Clipboard();
                    clipboard.customerId = this.loginService.currentUser.customerId;
                    clipboard.userId = this.loginService.currentUser.id;
                    clipboard.isCut = false;
                    clipboard.objectId = this.selectedCategoryId;
                    clipboard.content = 'grp';
                    this.catalogService.saveClipboard2Subscribe(clipboard).subscribe(() => {
                        var selectedRowData = this.catalogService.treeList.instance.getSelectedRowsData()[0];
                        this.buildContextMenu(selectedRowData.isChild, selectedRowData.type);
                    });
                    break;
                case 11: //Kategorie ausschneiden
                    var clipboard = new Clipboard();
                    clipboard.customerId = this.loginService.currentUser.customerId;
                    clipboard.userId = this.loginService.currentUser.id;
                    clipboard.isCut = true;
                    clipboard.objectId = this.selectedCategoryId;
                    clipboard.content = 'grp';
                    this.catalogService.saveClipboard(clipboard);
                    break;
                case 12: //Produkt kopieren
                    var clipboard = new Clipboard();
                    clipboard.customerId = this.loginService.currentUser.customerId;
                    clipboard.userId = this.loginService.currentUser.id;
                    clipboard.isCut = false;
                    clipboard.isMaster = this.product.productCount > 0;
                    clipboard.objectId = this.selectedProductId;
                    clipboard.content = 'pro';
                    this.catalogService.saveClipboard2Subscribe(clipboard).subscribe(() => {
                        var selectedRowData = this.catalogService.treeList.instance.getSelectedRowsData()[0];
                        this.buildContextMenu(selectedRowData.isChild, selectedRowData.type);
                    });
                    break;
                case 13: //Produkt ausschneiden
                    var clipboard = new Clipboard();
                    clipboard.customerId = this.loginService.currentUser.customerId;
                    clipboard.userId = this.loginService.currentUser.id;
                    clipboard.isCut = true;
                    clipboard.isMaster = this.product.productCount >= 0;
                    clipboard.objectId = this.selectedProductId;
                    clipboard.content = 'pro';
                    this.catalogService.saveClipboard2Subscribe(clipboard).subscribe(() => {
                        var selectedRowData = this.catalogService.treeList.instance.getSelectedRowsData()[0];
                        this.buildContextMenu(selectedRowData.isChild, selectedRowData.type);
                    });
                    break;
                case 20: //Als Kategorie kopieren
                    var clipboard = new Clipboard();
                    clipboard.customerId = this.loginService.currentUser.customerId;
                    clipboard.userId = this.loginService.currentUser.id;
                    clipboard.isCut = false;
                    clipboard.objectId = this.selectedCatalogId;
                    clipboard.content = 'cat';
                    this.catalogService.saveClipboard2Subscribe(clipboard).subscribe(() => {
                        var selectedRowData = this.catalogService.treeList.instance.getSelectedRowsData()[0];
                        this.buildContextMenu(selectedRowData.isChild, selectedRowData.type);
                    });
                    break;
                case 21:
                    //Katalog einfügen
                    this.catalogService.pasteItem(this.catalogService.catalog.id);
                    break;
                case 22:
                    //Item einfügen
                    this.catalogService.pasteItem(this.selectedCategoryId);
                    break;
                case 24:
                    //Massendatenbearbeitung Produkt als Vorlage benutzen
                    this.catalogService
                        .getProduct(
                            this.selectedProductId,
                            this.loginService.currentCustomer.id,
                            this.catalogService.catalog.id
                        )
                        .subscribe((result: Product) => {
                            this.emptyProduct = this.productService.getProductFromJson(
                                result,
                                this.loginService.wawiSettings
                            );
                        });
                    break;
            }
        }
    }

    //BROWSING
    public model: Catalog;
    public category: Category;
    public _product: Product;

    get product(): Product {
        return this._product;
    }

    set product(value: Product) {
        this._product = value;
    }

    get isCatalogSelected() {
        return this.catalogService.isCatalogSelected;
    }

    get isCategorySelected() {
        return this.catalogService.isCategorySelected;
    }

    get isProductSelected() {
        return this.catalogService.isProductSelected;
    }

    isVirtualCatalog(): boolean {
        return this.model?.isVirtual;
    }

    isDemoCatalog(): boolean {
        var catalog =
            this.model ??
            this.catalogService.catalog ??
            this.catalogService.catalogs.find((x) => x.id == this.catalogService.selectedCatalogId);
        return catalog?.isDemoCatalog;
    }

    onSelectItem(e) {
        if (this.massDataChange && this.isSearch(undefined) && e.currentSelectedRowKeys[0]) {
            var newlySelectedItem = e.selectedRowsData.find((x) => x.treeElementId == e.currentSelectedRowKeys[0]);
            if (newlySelectedItem.type != 'pro') {
                var deselectKeys = [];
                deselectKeys.push(newlySelectedItem.treeElementId);
                e.component.deselectRows(deselectKeys);
                this.systemService.notifyWarning(
                    this.translate.instant('Wenn der Filter aktiv ist, können nur Produkte selektiert werden!')
                );
            }
        }
        if (this.multiSelect && !this.massDataChange) {
            return;
        }
        if (e.selectedRowsData.length > 0) {
            this.catalogService.selectedNode = e.node;
            let selectedRowData = e.selectedRowsData[0];
            this.openItem(selectedRowData.type, selectedRowData.id, selectedRowData.isChild, selectedRowData.text);
        }
    }

    onRowClickItem(e) {
        if (!this.multiSelect || this.massDataChange || this.massGenerateKITexts) {
            return;
        }
        const row = e?.data;
        if (!row) {
            return;
        }
        this.catalogService.selectedNode = e.node;
        this.openItem(row.type, row.id, row.isChild, row.text);
    }

    txtKategorieHinzufuegen: string;
    txtKategorieEinfuegen: string;
    txtKatalogEinfuegen: string;
    txtProduktHinzufuegen: string;
    txtVarianteHinzufuegen: string;
    txtKategorieLoeschen: string;
    txtKategorieKopieren: string;
    txtProduktEinfuegen: string;
    txtProduktKopieren: string;
    txtProduktLoeschen: string;
    txtProduktDuplizieren: string;
    txtKopierenAlsKategorie: string;

    private translateTexts() {
        this.txtKategorieHinzufuegen = this.translate.instant('Kategorie hinzufügen');

        this.txtKategorieEinfuegen = this.translate.instant('Kategorie einfügen');
        this.txtKatalogEinfuegen = this.translate.instant('Katalog einfügen');

        this.txtProduktHinzufuegen = this.translate.instant('Produkt hinzufügen');
        this.txtVarianteHinzufuegen = this.translate.instant('Variante hinzufügen');
        this.txtKategorieLoeschen = this.translate.instant('Kategorie löschen');
        this.txtKategorieKopieren = this.translate.instant('Kategorie kopieren');
        this.txtProduktEinfuegen = this.translate.instant('Produkt einfügen');
        this.txtProduktKopieren = this.translate.instant('Produkt kopieren');
        this.txtKopierenAlsKategorie = this.translate.instant('Kopieren als Kategorie');
        this.txtProduktLoeschen = this.translate.instant('Produkt löschen');
        this.txtProduktDuplizieren = this.translate.instant('Produkt duplizieren');
    }

    private openItem(type: string, id: string, isChild: boolean, text: string = "") {
        this.catalogService.isCategorySelected = false;
        this.catalogService.isCatalogSelected = false;
        this.catalogService.isProductSelected = false;
        this.translationService.productTranslation = null;

        this.catalogService.product = null;
        this.catalogService.category = null;

        switch (type) {
            case 'cat':
                this.catalogService.isCatalogSelected = true;
                this.selectedCatalogId = id;
                this.goUrl(['info']);
                this.catalogService
                    .getCatalog(
                        this.catalogService.selectedCatalogId,
                        this.loginService.currentUser.customerId
                    )
                    .subscribe(() => {
                        this.model = this.catalogService.catalog;
                        this.buildContextMenu(isChild, type, text);
                    });
                break;

            case 'grp':
                this.catalogService.isCategorySelected = true;
                this.selectedCategoryId = id;
                this.goUrl(['category', this.selectedCategoryId]);
                this.catalogService
                    .getCategory(id, this.loginService.currentUser.customerId)
                    .subscribe(() => {
                        this.category = this.catalogService.category;
                        this.buildContextMenu(isChild, type, text);
                    });
                break;

            case 'pro':
                this.catalogService.isProductSelected = true;
                this.selectedProductId = id;
                this.goUrl(['product', this.selectedProductId]);
                this.catalogService
                    .getProduct(
                        id,
                        this.loginService.currentUser.customerId,
                        this.catalogService.catalog.id
                    )
                    .subscribe(() => {
                        this.product = this.catalogService.product;
                        if (
                            this.loginService.selectedTranslateLanguage !=
                            this.loginService.currentCustomer.defaultLanguage
                        ) {
                            this.translationService.getProductTranslation(
                                this.catalogService.catalog.id,
                                this.product.id
                            );
                        }
                        this.validationService.validateProduct(this.catalogService.product);
                        this.buildContextMenu(isChild, type, text);
                    });
                break;
        }
    }

    buildContextMenu(isChild: boolean, type: string, text: string = "") {
        this.menuItems = [];
        if (this.canView('rightclickCatalog') && !this.massDataChange && !this.readOnly('rightclickCatalog')) {
            switch (type) {
                case 'cat':
                    if (!this.isDemoCatalog())
                        this.menuItems.push({
                            id: 2,
                            text: this.txtKategorieHinzufuegen,
                            icon: 'glyphicon glyphicon-plus',
                            beginGroup: true
                        });
                    if (!this.isVirtualCatalog()) {
                        this.menuItems.push({
                            id: 20,
                            text: this.txtKopierenAlsKategorie,
                            icon: 'glyphicon glyphicon-copy',
                            beginGroup: true
                        });
                    }

                    if (!this.isDemoCatalog()) {
                        this.catalogService.loadClipboard().subscribe(() => {
                            var clipboard = this.catalogService.clipboard;
                            if (clipboard != null && clipboard.content == 'grp' && !this.isVirtualCatalog()) {
                                this.menuItems.push({
                                    id: 14,
                                    text: this.txtKategorieEinfuegen,
                                    icon: 'glyphicon glyphicon-paste',
                                    beginGroup: true
                                });
                            }
                            if (clipboard != null && clipboard.content == 'cat' && !this.isVirtualCatalog()) {
                                this.menuItems.push({
                                    id: 21,
                                    text: this.txtKatalogEinfuegen,
                                    icon: 'glyphicon glyphicon-paste',
                                    beginGroup: true
                                });
                            }
                        });
                    }
                    break;

                case 'grp':
                    //if (this.canView('rightclickCatalog')) {    // unnötig
                    this.menuItems = [];

                    if (!this.isDemoCatalog()) {
                        this.menuItems.push({
                            id: 2,
                            text: this.txtKategorieHinzufuegen,
                            icon: 'glyphicon glyphicon-plus',
                            beginGroup: false
                        });
                        this.menuItems.push({
                            id: 7,
                            text: this.txtKategorieLoeschen,
                            icon: 'glyphicon glyphicon-trash',
                            beginGroup: true
                        });
                    } else if (text == "undefiniert") {
                        this.menuItems.push({
                            id: 7,
                            text: this.txtKategorieLoeschen,
                            icon: 'glyphicon glyphicon-trash',
                            beginGroup: true
                        });

                    }
                    if (!this.isVirtualCatalog()) {
                        this.menuItems.push({
                            id: 5,
                            text: this.txtProduktHinzufuegen,
                            icon: 'glyphicon glyphicon-plus',
                            beginGroup: true
                        });
                    }
                    if (!this.isVirtualCatalog()) {
                        this.menuItems.push({
                            id: 10,
                            text: this.txtKategorieKopieren,
                            icon: 'glyphicon glyphicon-copy',
                            beginGroup: true
                        });
                    }
                    //this.menuItems.push({ id: 11, text: "Kategorie ausschneiden", icon: 'glyphicon glyphicon-copy', beginGroup: false });

                    this.catalogService.loadClipboard().subscribe(() => {
                        if (this.catalogService.clipboard != null) {
                            var clipboard = this.catalogService.clipboard;
                            if (clipboard.content == 'pro' && !this.isVirtualCatalog()) {
                                this.menuItems.push({
                                    id: 6,
                                    text: this.txtProduktEinfuegen,
                                    icon: 'glyphicon glyphicon-paste',
                                    beginGroup: true
                                });
                            }
                            if (clipboard.content == 'grp' && !this.isVirtualCatalog() && !this.isDemoCatalog()) {
                                this.menuItems.push({
                                    id: 6,
                                    text: this.txtKategorieEinfuegen,
                                    icon: 'glyphicon glyphicon-paste',
                                    beginGroup: true
                                });
                            }
                            if (clipboard.content == 'cat' && !this.isVirtualCatalog() && !this.isDemoCatalog()) {
                                this.menuItems.push({
                                    id: 22,
                                    text: this.txtKatalogEinfuegen,
                                    icon: 'glyphicon glyphicon-paste',
                                    beginGroup: true
                                });
                            }
                        }
                    });
                    //}
                    break;

                case 'pro':
                    //if (this.canView('rightclickCatalog')) {    // unnötig
                    this.menuItems = [];
                    if (!this.isVirtualCatalog()) {
                        this.menuItems.push({
                            id: 5,
                            text: this.txtVarianteHinzufuegen,
                            icon: 'glyphicon glyphicon-plus',
                            beginGroup: true
                        });
                        this.menuItems.push({
                            id: 8,
                            text: this.txtProduktDuplizieren,
                            icon: 'glyphicon glyphicon-duplicate',
                            beginGroup: false
                        });
                    }
                    this.menuItems.push({
                        id: 0,
                        text: this.txtProduktLoeschen,
                        icon: 'glyphicon glyphicon-trash',
                        beginGroup: true
                    });
                    if (!this.isVirtualCatalog()) {
                        this.menuItems.push({
                            id: 12,
                            text: this.txtProduktKopieren,
                            icon: 'glyphicon glyphicon-copy',
                            beginGroup: true
                        });
                    }

                    if (isChild) {
                        this.menuItems = [];
                        if (!this.isVirtualCatalog()) {
                            this.menuItems.push({
                                id: 8,
                                text: this.txtProduktDuplizieren,
                                icon: 'glyphicon glyphicon-duplicate',
                                beginGroup: false
                            });
                            this.menuItems.push({
                                id: 0,
                                text: this.txtProduktLoeschen,
                                icon: 'glyphicon glyphicon-trash',
                                beginGroup: true
                            });
                            this.menuItems.push({
                                id: 12,
                                text: this.txtProduktKopieren,
                                icon: 'glyphicon glyphicon-copy',
                                beginGroup: true
                            });
                        }
                    }
                    if (!isChild) {
                        this.catalogService.loadClipboard().subscribe(() => {
                            if (this.catalogService.clipboard != null) {
                                var clipboard = this.catalogService.clipboard;
                                if (
                                    clipboard.content == 'pro' &&
                                    !(
                                        clipboard.isMaster &&
                                        (this.catalogService.product == null || this.product.productCount > 0)
                                    )
                                ) {
                                    this.menuItems.push({
                                        id: 9,
                                        text: this.txtProduktEinfuegen,
                                        icon: 'glyphicon glyphicon-paste',
                                        beginGroup: true
                                    });
                                }
                            }
                        });
                    }
                    //}
                    break;
            }
        } else if (this.massDataChange) {
            switch (type) {
                case 'pro':
                    this.menuItems.push({
                        id: 24,
                        text: this.translate.instant('Als Vorlage benutzen'),
                        icon: 'glyphicon glyphicon-copy',
                        beginGroup: true
                    });
                    break;
                case 'grp':
                    this.menuItems.push({
                        id: 25,
                        text: this.translate.instant('Vorlagen benutzten'),
                        icon: 'glyphicon glyphicon-copy',
                        beginGroup: true
                    });
                    break;
            }
        }
    }


    showTranslateBox() {
        if (!this.catalogService.catalog) {
            return false;
        }

        return (
            this.loginService.hasAddonTranslate &&
            this.catalogService.catalog.language.toLowerCase() ==
            this.loginService.currentCustomer.defaultLanguage.toLowerCase()
        );
    }


    createChildren = async (parent) => {
        let parentId = parent ? parent.itemData.id : '';
        this.childs = await this.catalogService.getChilds(
            this.catalogService.selectedCatalogId,
            parentId,
            this.loginService.currentUser.customerId,
            null,
            this.catalogService.selectedStates,
            null,
            this.selectedStatesMode
        );
        return this.childs;
    };

    //TOOLTIPS
    public v: boolean[] = [false];
    public t: boolean[] = [false];

    olf(id) {
        this.t[id] = !this.t[id];
    }

    ttt(id) {
        if (this.loginService.showToolTips) {
            this.v[id] = !this.v[id];
        }
    }

    //SETTINGS
    get showToolTips(): boolean {
        return this.loginService.showToolTips;
    }

    get showProToolTips(): boolean {
        return this.loginService.showProToolTips;
    }

    get showPlaceHolders(): boolean {
        return this.loginService.showPlaceHolders;
    }

    toggleMenu() {
        this.systemService.showMenu = !this.systemService.showMenu;
    }

    toggleHelp() {
        this.systemService.showHelp = !this.systemService.showHelp;
        if (this.systemService.showHelp) {
            this.systemService
                .loadHelp(this.loginService.currentUser.customerId)
                .subscribe((result: CustomerWiki) => (this.systemService.help = result.entries));
        }
    }

    canView(name: string): boolean {
        return this.userManagment.canView(name);
    }

    readOnly(name: string, catalog: Catalog = this.catalogService.catalog): boolean {
        return !this.userManagment.canEdit(name, catalog);
    }

    treeListMode() {
        if (this.massDataChange || this.massGenerateKITexts || this.multiSelect) return 'multiple';
        return 'single';
    }

    public getSelectedProductSupplierPids(): string[] {
        return this.getSelection().supplierPids;
    }

    public getSelection(): { allInState: boolean; supplierPids: string[] } {
        const instance = this.treeList?.instance;
        if (!instance) {
            return { allInState: false, supplierPids: [] };
        }
        const selectedKeys: string[] = instance.getSelectedRowKeys('all') ?? [];
        const loaded = this.catalogTree?.getLoadedData() ?? [];
        const byKey = new Map<string, any>(loaded.map((data) => [data.treeElementId, data]));
        const selectedData = selectedKeys
            .map((key) => byKey.get(key) ?? instance.getNodeByKey(key)?.data)
            .filter((data) => !!data);
        const allInState = selectedData.some((data) => data.type === 'cat');
        const supplierPids = selectedData
            .filter((data) => data.type === 'pro' && data.supplierPid)
            .map((data) => data.supplierPid);
        return { allInState, supplierPids };
    }

    public emptyProduct: Product = new Product();

    setEmptyProduct(product: Product) {
        this.treeSelectedRowKeys = [];
        this.emptyProduct = product;
        this.emptyProduct.productLogistic = new ProductLogistic();
        this.massDataChange = true;
        this.massGenerateKITexts = false;
    }

    massCancel(event) {
        this.massDataChange = false;
        this.massGenerateKITexts = false;
        if (event.idToSelect && event.isNewlyAdded) {
            this.openItem('pro', event.idToSelect, false);
            this.catalogService
                .GetProductTreeItem(
                    event.idToSelect,
                    this.loginService.currentCustomer.id,
                    '',
                    this.selectedCatalogId
                )
                .subscribe((x) => {
                    this.selectProductAfterSearch = x;
                    this.catalogService.treeRefresh();
                });
            return;
        }
        if (event.idToSelect) {
            this.openItem('pro', event.idToSelect, false);
            this.treeList.instance.selectRows([event.idToSelect], false);
        } else if (this.isCatalogSelected) {
            this.treeList.instance.selectRows([this.selectedCatalogId], false);
        } else if (this.isCategorySelected) {
            this.treeList.instance.selectRows([this.selectedCategoryId], false);
        } else if (this.isProductSelected) {
            this.treeList.instance.selectRows([this.selectedProductId], false);
        } else {
            this.treeList.instance.selectRows([this.catalogService.catalog.id], false);
        }
    }

    showMassGenerateKITexts() {
        this.massGenerateKITexts = true;
        this.massDataChange = false;
    }

    startMassGenerateKITexts() {
        this.massGenerateKITexts = false;
    }
}
